import styled from 'styled-components/macro'

export const LoadingWrapper = styled.div`
height: 90px;
width: 100%;
display: grid;
place-items: center;
`
